(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["social-proof-stars"] && !Shopify.designMode) return;
  try {
    const DAILY_MIN = 8;
  const DAILY_MAX = 12;
  const RATING_MIN = 4.7;
  const RATING_MAX = 4.9;
  const COUNT_JITTER = 50;
  const DAY_IN_MS = 24 * 60 * 60 * 1000;

  /**
   * Hashes a string into a 32-bit unsigned integer (FNV-1a).
   * @param {string} value
   * @returns {number}
   */
  const hashString = (value) => {
    let hash = 0x811c9dc5;

    for (const char of value) {
      hash ^= char.charCodeAt(0);
      hash = Math.imul(hash, 0x01000193);
    }

    return hash >>> 0;
  };

  /**
   * Creates a deterministic pseudo-random number generator seeded by an integer.
   * @param {number} seed
   * @returns {() => number} Function returning a float between 0 (inclusive) and 1 (exclusive).
   */
  const createSeededRandom = (seed) => {
    let state = seed;

    return () => {
      state |= 0;
      state = (state + 0x6d2b79f5) | 0;
      let t = Math.imul(state ^ (state >>> 15), 1 | state);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  };

  /**
   * Returns today's date as YYYY-MM-DD in the given IANA timezone.
   * @param {string} timeZone
   * @returns {string}
   */
  const getTodayInTimeZone = (timeZone) => {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(new Date());
    } catch {
      return new Intl.DateTimeFormat('en-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(new Date());
    }
  };

  /**
   * Counts whole days between two YYYY-MM-DD dates, treated as UTC calendar dates.
   * @param {string} startDate
   * @param {string} endDate
   * @returns {number}
   */
  const daysBetween = (startDate, endDate) => {
    const [startYear, startMonth, startDay] = startDate.split('-').map(Number);
    const [endYear, endMonth, endDay] = endDate.split('-').map(Number);
    const start = Date.UTC(startYear, startMonth - 1, startDay);
    const end = Date.UTC(endYear, endMonth - 1, endDay);
    return Math.max(0, Math.round((end - start) / DAY_IN_MS));
  };

  /**
   * @extends {HTMLElement}
   */
  class SocialProofStars extends HTMLElement {
    connectedCallback() {
      this.#render();
    }

    #render() {
      const baseCount = Number(this.dataset.baseCount) || 0;
      const anchorDate = this.dataset.anchorDate;
      const timeZone = this.dataset.timezone || 'UTC';

      if (!anchorDate) return;

      const seedKey = `${anchorDate}|${timeZone}`;
      const jitterRandom = createSeededRandom(hashString(`${seedKey}|jitter`));
      const jitter = Math.round((jitterRandom() * 2 - 1) * COUNT_JITTER);

      const today = getTodayInTimeZone(timeZone);
      const daysElapsed = daysBetween(anchorDate, today);

      let grown = 0;
      for (let day = 0; day < daysElapsed; day += 1) {
        const dayRandom = createSeededRandom(hashString(`${seedKey}|day-${day}`));
        grown += DAILY_MIN + Math.floor(dayRandom() * (DAILY_MAX - DAILY_MIN + 1));
      }

      const finalCount = baseCount + jitter + grown;

      const ratingRandom = createSeededRandom(hashString(`${seedKey}|rating`));
      const rating = (RATING_MIN + ratingRandom() * (RATING_MAX - RATING_MIN)).toFixed(2);

      this.#updateLabel(finalCount, rating);
      this.#updateStars(Number(rating));
    }

    /**
     * @param {number} count
     * @param {string} rating
     */
    #updateLabel(count, rating) {
      const label = this.querySelector('[data-label]');
      if (!label) return;

      const formattedCount = new Intl.NumberFormat('en-US').format(count);

      label.innerHTML = label.innerHTML
        .split('[[count]]')
        .join(formattedCount)
        .split('[[rating]]')
        .join(rating);
    }

    /**
     * @param {number} rating
     */
    #updateStars(rating) {
      const fill = this.querySelector('[data-stars-fill]');
      if (fill) {
        fill.style.width = `${(rating / 5) * 100}%`;
      }

      const starsLabel = this.querySelector('[data-stars-label]');
      if (starsLabel) {
        starsLabel.textContent = `Rated ${rating} out of 5`;
      }
    }
  }

  customElements.define('social-proof-stars', SocialProofStars);
  } catch(e) { console.error(e); }
})();

})();
